

let kpLang = {

    csIng: {
        eng: 'Connecting...',
        cht: '連線中...',
    },
    csLogin: {
        eng: 'Logged in',
        cht: '已登入',
    },
    csLogout: {
        eng: 'Logged out',
        cht: '已登出',
    },
    csErrConn: {
        eng: 'Unable to connect',
        cht: '無法連線',
    },
    csErrLogin: {
        eng: 'Login denied',
        cht: '拒絕登入',
    },

    aggridLanguage: {
        eng: 'en',
        cht: 'zh-tw',
    },

    systemMessage: {
        eng: 'System message',
        cht: '系統確認訊息',
    },
    ok: {
        eng: 'OK',
        cht: '確認',
    },
    no: {
        eng: 'No',
        cht: '取消',
    },
    yes: {
        eng: 'Yes',
        cht: '確定',
    },

    empty: {
        eng: 'Empty',
        cht: '無',
    },
    waitingData: {
        eng: 'Waiting data...',
        cht: '等待數據中...',
    },

    isEditabled: {
        eng: 'Editable',
        cht: '是否編輯',
    },
    saveChanges: {
        eng: `Save changes`,
        cht: `儲存變更`,
    },
    id: {
        eng: `Id`,
        cht: `主鍵`,
    },
    from: {
        eng: `From`,
        cht: `來源`,
    },
    save: {
        eng: `Save`,
        cht: `儲存`,
    },
    close: {
        eng: `Close`,
        cht: `關閉`,
    },
    delete: {
        eng: `Delete`,
        cht: `刪除`,
    },
    cancel: {
        eng: `Cancel`,
        cht: `取消`,
    },
    screenFull: {
        eng: `Max size`,
        cht: `最大化尺寸`,
    },
    screenNormal: {
        eng: `Normal size`,
        cht: `預設尺寸`,
    },
    checkAllYes: {
        eng: `Check all`,
        cht: `全選使用`,
    },
    checkAllNo: {
        eng: `Uncheck all`,
        cht: `全不選使用`,
    },
    checkAllInv: {
        eng: `Reverse all`,
        cht: `全反選使用`,
    },
    operMode: {
        eng: `Enable`,
        cht: `是否使用`,
    },
    operPemiEnable: {
        eng: `Operator`,
        cht: `合併權限模式`,
    },
    operGrupEnable: {
        eng: `Operator`,
        cht: `合併權限群組模式`,
    },

    processing: {
        eng: `Processing...`,
        cht: `處理中請稍後...`,
    },
    anUnexpectedErrorOccurred: {
        eng: `An unexpected error occurred, please contact the administrator`,
        cht: `發生非預期錯誤，請洽管理員`,
    },
    unknow: {
        eng: `Unknow`,
        cht: `未知`,
    },

    username: {
        eng: `Username`,
        cht: `使用者姓名`,
    },
    email: {
        eng: `Email`,
        cht: `電子郵件`,
    },
    name: {
        eng: `Name`,
        cht: `名稱`,
    },
    description: {
        eng: `Description`,
        cht: `說明`,
    },
    // noDescription: {
    //     eng: `No description`,
    //     cht: `無說明`,
    // },
    modeEdit: {
        eng: `Edit mode`,
        cht: `編輯模式`,
    },
    showTabCols: {
        eng: `Show columns`,
        cht: `顯示欄位`,
    },

    menuTreeShow: {
        eng: 'Show API list',
        cht: '顯示API清單',
    },
    menuTreeHide: {
        eng: 'Hide API list',
        cht: '隱藏API清單',
    },

    noSelectApi: {
        eng: 'No Select',
        cht: '尚未選擇API',
    },
    tokens: {
        eng: 'Tokens',
        cht: '授權金鑰',
    },
    apiUrl: {
        eng: 'API url',
        cht: 'API網址',
    },
    version: {
        eng: 'Version',
        cht: '版本',
    },
    levels: {
        eng: 'Levels',
        cht: '所屬階層',
    },
    keywords: {
        eng: 'Keywords',
        cht: '關鍵字',
    },
    state: {
        eng: 'State',
        cht: '狀態',
    },
    timeCreate: {
        eng: 'Create time',
        cht: '創建時間',
    },
    timeUpdate: {
        eng: 'Update time',
        cht: '更新時間',
    },
    creator: {
        eng: 'Creator',
        cht: 'API創建者',
    },
    dataSource: {
        eng: 'Source',
        cht: '資料提供者',
    },
    isActive: {
        eng: 'Active',
        cht: '有效',
    },
    mdInputParams: {
        eng: 'Input',
        cht: '輸入參數資訊或結構',
    },
    inputExample: {
        eng: 'Input example',
        cht: '輸入範例',
    },
    mdOutputParams: {
        eng: 'Output',
        cht: '回傳數據結構',
    },
    outputExample: {
        eng: 'Output example',
        cht: '回傳數據範例',
    },

    outputMenuTree: {
        eng: 'Tree',
        cht: '樹狀組件',
    },
    outputMenuRaw: {
        eng: 'Raw',
        cht: '原始數據',
    },

}


export default kpLang
